// Printed material sheet — letter portrait, same popup pattern as the timesheet/fab prints.
/* eslint-disable */
const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const money = (n) => '$' + Number(n || 0).toFixed(2);
const fmtQty = (q) => (Number.isInteger(Number(q)) ? String(Number(q)) : String(Number(q)));

export function printMaterialSheet(s) {
  const pw = window.open('', '_blank');
  if (!pw) return;
  const date = s.date ? new Date(s.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '';
  const status = s.status === 'void' ? 'VOID' : s.status === 'issued' ? (s.needs_wo ? 'ISSUED — NEEDS WORK ORDER' : 'ISSUED') : 'DRAFT';
  const cons = (s.lines || []).filter(l => l.kind !== 'equipment');
  const equip = (s.lines || []).filter(l => l.kind === 'equipment');
  const basisLbl = { day: 'Daily', week: 'Weekly', month: 'Monthly' };
  const rows = cons.map((l, i) => `
    <tr>
      <td class="c">${i + 1}</td>
      <td><div class="nm">${esc(l.name)}</div>${l.note ? `<div class="nt">${esc(l.note)}</div>` : ''}</td>
      <td class="mono">${esc(l.part_number || '')}</td>
      <td class="c mono">${fmtQty(l.qty)}</td>
      <td class="c">${esc(l.unit || 'each')}</td>
      <td class="r mono">${money(l.unit_price)}</td>
      <td class="r mono b">${money(l.total)}</td>
    </tr>`).join('');
  const blank = Math.max(0, (equip.length ? 3 : 6) - cons.length);
  const blanks = Array.from({ length: blank }).map(() => '<tr class="blank"><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td></tr>').join('');
  const consTotal = cons.reduce((a, l) => a + (Number(l.total) || 0), 0);
  const equipTotal = equip.reduce((a, l) => a + (Number(l.total) || 0), 0);
  const equipRows = equip.map((l, i) => `
    <tr>
      <td class="c">${i + 1}</td>
      <td><div class="nm">${esc(l.name)}</div>${l.note ? `<div class="nt">${esc(l.note)}</div>` : ''}</td>
      <td class="c">${esc(basisLbl[l.rate_basis] || 'Daily')}</td>
      <td class="c mono">${fmtQty(l.qty)} ${esc(l.unit || 'day')}${Number(l.qty) === 1 ? '' : 's'}</td>
      <td class="r mono">${money(l.unit_price)}</td>
      <td class="r mono b">${money(l.total)}</td>
    </tr>`).join('');
  const equipTable = equip.length ? `
  <h2 style="margin:16px 0 4px;font-size:13px;color:#1e3a8a;text-transform:uppercase;letter-spacing:.06em">365 Equipment — charged at listed rates</h2>
  <table>
    <thead><tr><th class="c" style="width:28px">#</th><th>Equipment</th><th class="c" style="width:70px">Rate</th><th class="c" style="width:90px">Period</th><th class="r" style="width:80px">Rate $</th><th class="r" style="width:90px">Total</th></tr></thead>
    <tbody>${equipRows}</tbody>
    <tfoot><tr><td colspan="4"></td><td class="r b">EQUIPMENT</td><td class="r mono b">${money(equipTotal)}</td></tr></tfoot>
  </table>` : '';

  pw.document.write(`<!DOCTYPE html><html><head><title>Material Sheet ${esc(s.number)}</title>
  <style>
    @page { size: letter portrait; margin: 0.5in; }
    * { box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; color: #111; margin: 0; font-size: 12px; }
    .hdr { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #1e3a8a; padding-bottom: 10px; }
    .hdr img { height: 54px; }
    .hdr .t { text-align: right; }
    .hdr h1 { margin: 0; font-size: 22px; letter-spacing: 2px; color: #1e3a8a; }
    .hdr .num { font-family: 'Courier New', monospace; font-size: 16px; font-weight: bold; margin-top: 2px; }
    .hdr .st { display: inline-block; margin-top: 4px; padding: 2px 8px; border: 1.5px solid #333; border-radius: 4px; font-size: 10px; font-weight: bold; letter-spacing: 1px; }
    .hdr .st.void { color: #b91c1c; border-color: #b91c1c; }
    .meta { display: grid; grid-template-columns: 1fr 1fr; gap: 6px 24px; margin: 14px 0 16px; }
    .meta div { border-bottom: 1px solid #cbd5e1; padding: 4px 0; display: flex; gap: 8px; }
    .meta label { font-size: 10px; text-transform: uppercase; letter-spacing: .5px; color: #64748b; min-width: 110px; }
    .meta span { font-weight: bold; }
    .meta .wo { font-family: 'Courier New', monospace; font-size: 15px; color: #1e3a8a; }
    .meta .nowo { color: #b45309; }
    table { width: 100%; border-collapse: collapse; }
    th { background: #1e3a8a; color: #fff; font-size: 10px; text-transform: uppercase; letter-spacing: .5px; padding: 7px 6px; text-align: left; }
    td { padding: 6px; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
    tr.blank td { height: 26px; }
    .c { text-align: center; } .r { text-align: right; } .b { font-weight: bold; }
    .mono { font-family: 'Courier New', monospace; }
    .nm { font-weight: 600; } .nt { font-size: 10px; color: #64748b; margin-top: 1px; }
    tfoot td { border-top: 2px solid #1e3a8a; border-bottom: none; font-size: 13px; padding-top: 8px; }
    .notes { margin-top: 14px; border: 1px solid #cbd5e1; border-radius: 4px; padding: 8px; min-height: 48px; }
    .notes label { font-size: 10px; text-transform: uppercase; color: #64748b; display: block; margin-bottom: 3px; }
    .sig { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 28px; margin-top: 34px; }
    .sig div { border-top: 1px solid #333; padding-top: 4px; font-size: 10px; color: #475569; text-transform: uppercase; }
    .foot { margin-top: 18px; font-size: 9px; color: #64748b; display: flex; justify-content: space-between; }
    @media print { .noprint { display: none; } }
  </style></head><body>
  <div class="hdr">
    <img src="${window.location.origin}/365-logo-dark.png" alt="365 Industrial Solutions" onerror="this.style.display='none'" />
    <div class="t"><h1>MATERIAL SHEET</h1><div class="num">${esc(s.number)}</div><span class="st ${s.status === 'void' ? 'void' : ''}">${status}</span></div>
  </div>
  <div class="meta">
    <div><label>Work order</label><span class="${s.work_order_number ? 'wo' : 'nowo'}">${s.work_order_number ? esc(s.work_order_number) : 'NO WO — office to assign'}</span></div>
    <div><label>Date</label><span>${esc(date)}</span></div>
    <div><label>Customer</label><span>${esc(s.customer || (s.work_order_number ? '' : 'Counter sale'))}</span></div>
    <div><label>Prepared by</label><span>${esc(s.created_by && s.created_by.name)}</span></div>
    <div><label>Job</label><span>${esc(s.job_title || '')}</span></div>
    <div><label>Project manager</label><span>${esc(s.pm_name || '')}</span></div>
  </div>
  <table>
    <thead><tr><th class="c" style="width:28px">#</th><th>Item</th><th style="width:90px">Part #</th><th class="c" style="width:50px">Qty</th><th class="c" style="width:60px">Unit</th><th class="r" style="width:80px">Unit price</th><th class="r" style="width:90px">Total</th></tr></thead>
    <tbody>${rows}${blanks}</tbody>
    <tfoot><tr><td colspan="5"></td><td class="r b">${equip.length ? 'CONSUMABLES' : 'TOTAL'}</td><td class="r mono b">${money(equip.length ? consTotal : s.subtotal)}</td></tr></tfoot>
  </table>
  ${equipTable}
  ${equip.length ? `<div style="text-align:right;margin-top:8px;font-size:14px"><b>SHEET TOTAL &nbsp; <span class="mono">${money(s.subtotal)}</span></b></div>` : ''}
  <div class="notes"><label>Notes</label>${esc(s.notes || '')}</div>
  <div class="sig"><div>Issued by (tool crib)</div><div>Received by</div><div>PM approval</div></div>
  <div class="foot"><span>Prices are sell prices from the 365 consumables list${equip.length ? '; equipment at the 365 day / week / month rate sheet' : ''}. Lines post to the job as pending charges when issued.</span><span>${esc(s.number)} · ${(s.lines || []).length} lines</span></div>
  <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 250); };</script>
  </body></html>`);
  pw.document.close();
}
